const ignoreIncluding = [
  /ResizeObserver loop limit exceeded/,
  /Cannot read properties of undefined (reading 'getIn')/,
  /ResizeObserver loop completed with undelivered notifications./,
];

const newRelicErrorHandler = (error?: Error | string): boolean => {
  if (error instanceof Error) {
    if (!error.message) {
      return true;
    }

    return ignoreIncluding.some((matcher) => error?.message.match(matcher));
  }

  return true;
};

export default newRelicErrorHandler;
